export default {
  showMask() {
    const mask = document.getElementById('app-mask');
    if (mask) {
      mask.style.display = 'block';
    }
  },
  hideMask() {
    const mask = document.getElementById('app-mask');
    if (mask) {
      mask.style.display = 'none';
    }
  },
};
